// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const DELETE_MODERATOR = "Nechcem moderova\u0165";
